
import "./AddUser.css"
import { useState,useEffect ,useContext} from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import BeatLoader from "react-spinners/BeatLoader";
import { faHome,faClipboard,faChartLine,faChevronDown,faUserShield } from '@fortawesome/free-solid-svg-icons'
import BeatLoader from "react-spinners/BeatLoader";
import useAxiosPrivate from "../../Hooks/useAxiosPrivate";
import useAuth from "../../Hooks/UseAuth";
import AuthContext from "../../Context/AuthProvider";
// AuthContext

function AddUser(){  

    
        // const [register,setRegister] = useState(true) 
        const [PhylState,setPhlState] = useState(true) 
        const [consist,setConsist] = useState(false) 
        const [creative,setCreative] = useState(false) 
        const[tData, setTData] = useState([]);
        const options = ["Male","Female"];
        const [deposit,setDepsit] =useState(true); 
        const [withdraw,setWithdraw] =useState(false); 
        const [email, setEmail] = useState('');
        const [name, setName] = useState('')
        // const [password, setPassword] = useState(''); 
        const [password, setPassword] = useState('nerd1234'); 
        // const auth = useAuth();
        // const {setAuth, auth} = useAuth()
        const [signUp, setSignup] = useState(false); 
        const [loginState, setLogin] = useState(true); 
        const [register, setRegister] = useState(false);
        const [Branch, setBranch] = useState("");
        const [AccNo, setAccNo] = useState("");
        const [Loading, setLoading] = useState(false);
        const [errorMsg, setErrorMsg] = useState(false);
        const [Msg, setMsg] = useState("");
        const [successMsg, setSuccessMsg] = useState(false);
        const [Gender, setGender] = useState("");
        const [Ssn, setSsn] = useState("");
        const [address, setAddress] = useState("");
        const [doh, setDoh] = useState("");
        const [FInstitution, setFInstitutionn] = useState("");
        const [Compensation, setCompensation] = useState("");
        const [nik, setNik] = useState("");
        const axiosPrivate = useAxiosPrivate();
        const { setAuth,auth } = useContext(AuthContext);
      
        
        const [nikRel, setNikRel] = useState("");
        const [nikAddress, setNikAddress] = useState("");
        const [nikContact, setNikContact] = useState("");
        const [position, setPosition] = useState("");
        const [AccountType, setAccountType] = useState("");
        const [AccountBranch, setAccountBranch] = useState("");
        
        
    
      
        // Status Message  Timeout
        setTimeout(() => {
            setSuccessMsg(false);
            setErrorMsg(false); 
        }, 12001);

        const phylHandler = ()=>{ 
                    
            setPhlState(!PhylState); 
            if(consist || creative){ 
                setConsist(false); 
                setCreative(false)

            }
            
          
        } 

        const creativeHandler = ()=>{ 
                    
            setCreative(!creative); 
            if(consist || PhylState){ 
            setPhlState(false); 
            setConsist(false)

            }
            
     
        }

        const consistHandler = ()=>{ 
                    
        setConsist(!consist); 
        if(PhylState || creative){ 
        setPhlState(false); 
        setCreative(false)

        }

        }

        const handleAuthForm = () =>{
          
            setLogin(!loginState); 
            setRegister(!register);
            
      }


        //Register user function
        // async function registerUser(e) {  
        //     e.preventDefault(); 
        //     setLoading(true);
        //     setSuccessMsg(false);
        //     setErrorMsg(false);
    
           
        //      const response = await fetch("https://nerdayb.onrender.com/api/register",{ 
        //             method : "POST",
        //             headers: { 
        //              "content-type" :   "application/json"
        //             }, 
        //             body: JSON.stringify({
        //                 name,
        //                 email,
        //                 Gender,
        //                 AccNo,
        //                 Compensation,
        //                 Ssn,
        //                 address,
        //                 position,
        //                 doh,
        //                 FInstitution,
        //                 AccountBranch,
        //                 AccountType,
        //                 nik,
        //                 address,
        //                 nikAddress,
        //                 address,
        //                 nikContact,
        //                 nikRel,


        //             })
                    
    
        //      }) 
    
        //      const data = await response.json();
        //      console.log(data);
    
          
    
        //       if(data.status == 'Ok'){
             

        //         setAccNo("");
        //         setAccountBranch("");
        //         setAddress("");
        //         setFInstitutionn(""); 
        //         setDoh("");
        //         setNik("");
        //         setNikAddress("");
        //         setNikRel("");
        //         setNikContact("");
        //         setPosition("");
        //         setAccountType("");
        //         setEmail("");
        //         setGender("");
        //         setCompensation("");
        //         setName("");
        //         setSsn("");
        //         setAccNo("");
                



        //         setLoading(false);
        //         setSuccessMsg(true)
        //         setMsg(data.msg)
                
        //         handleAuthForm()
        //       }else{
              
        //         setLoading(false);
        //         setMsg(data.msg)
        //         setErrorMsg(true);
        //       }
        // }

        async function registerUser(e) {  
            e.preventDefault(); 
            setLoading(true);
            setSuccessMsg(false);
            setErrorMsg(false);
    
         

             ////
             const response = await axiosPrivate.post("/users",
            //  const response = await axiosPrivate.post("http://localhost:2000/users",
                JSON.stringify({
                        name,
                        email,
                        Gender,
                        AccNo,
                        Compensation,
                        Ssn,
                        address,
                        position,
                        doh,
                        FInstitution,
                        AccountBranch,
                        AccountType,
                        nik,
                        address,
                        nikAddress,
                        address,
                        nikContact,
                        nikRel,
                        password,
                        Org: auth.foundUser.Org,
                    // name,
                    // email,
                    // Gender,
                    // AccNo,
                    // Compensation,
                    // Ssn,
                    // address,
                    // position,
                    // doh,
                    // FInstitution,
                    // AccountBranch,
                    // AccountType,
                  
                    // nik,
                    // address,
                    // nikAddress,
                    // address,
                    // nikContact,
                    // nikRel,
                    // name,
                    // password,
                    // Branch,
                    // SuperUser:auth.foundUser._id
                 }),
                // JSON.stringify({ user, pwd }),
                {
                    headers: { 'Content-Type': 'application/json',
                   
                 },
                    
                    withCredentials: true,
                    crossDomain: true,
                    
                }
            );
             ////
            console.log(response)
     
          
    
              if(response?.data?.status == 'Ok'){
                // navigate("/login");

                // setAccNo("");
                // setAccountBranch("");
                // setAddress("");
                // setFInstitutionn(""); 
                // setDoh("");
                // setNik("");
                // setNikAddress("");
                // setNikRel("");
                // setNikContact("");
                // setPosition("");
                // setAccountType("");
                // setEmail("");
                // setGender("");
                // setCompensation("");
                // setName("");
                // setSsn("");
                // setAccNo("");
                // setBranch("");
                



                setLoading(false);
                setSuccessMsg(true)
                setMsg(response?.data?.msg)



                setAccNo("");
                setAccountBranch("");
                setAddress("");
                setFInstitutionn(""); 
                setDoh("");
                setNik("");
                setNikAddress("");
                setNikRel("");
                setNikContact("");
                setPosition("");
                setAccountType("");
                setEmail("");
                setGender("");
                setCompensation("");
                setName("");
                setSsn("");
                setAccNo("");
                
                
                handleAuthForm()
              }else{
              
                // setLoading(false);
                // setMsg(response?.data?.msg)
                // setErrorMsg(true);

                setLoading(false);
                setMsg(response?.data.msg)
                setErrorMsg(true);
              }
        }

        
        
        async function populateData(){  

            // const response = await fetch("https://superagentback.onrender.com/api/Alltransactions",{
            const response = await fetch("https://nerdayb.onrender.com/api/Alltransactions",{
                headers : { 
                //   'x-access-token' : auth.user,
                  }
              // body: JSON.stringify({
              //     quote,
                  
              // })
            })
            
            const data = await response.json();
            console.log("All Data here",data.propdata)
            if(data){
    
           if(data.status == "ok") {
              setTData(data.propdata)
            }else{
            //    alert(data.error,"Here!")
               console.log("testign first")
            } 
    
         }

            
            return data;
            
      } 
    
      useEffect(()=>{ 
    
         populateData();
         console.log("test populate");
    
      },[])
        
    

    return( 

        <> 

                <div className="FeesCover">
                              <div className="FeesHeader">
                                    <h2>User Management</h2>
                              </div>

                                <div className="feesDropdown">
                                    {/* addDays */}
                                        <div className='Virtue'>  

                                                <div className='Virtues'>  


                                                {/* <div className={PhylState ? "PhylState Active": "PhylState"} onClick={phylHandler}>   */}

                                                {/* {register &&<> */}
                                                <>

                    <br/>
                    <h3>Register Employee</h3>
                        <form onSubmit={registerUser}>
                            {/* Name */}
                            <div className="txt_field">
                            <input
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                type="text"
                                required
                            />
                            <span></span>
                            <label>Name</label>

                            </div>
                            {/* SSN */}
                            <div className="txt_field">
                            <input
                                value={Ssn}
                                onChange={(e) => setSsn(e.target.value)}
                                type="text"
                                required
                            />
                            <span></span>
                            <label>NRC</label>

                            </div>

                            {/* Email */}
                            <div className="txt_field">
                            <input
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                type="email"
                                required
                            />
                            <span></span>
                            <label>Email</label>

                            </div>
                            {/* AccountNumber */}
                            <div className="txt_field">
                            <input
                                value={AccNo}
                                onChange={(e) => setAccNo(e.target.value)}
                                type="number"
                                required
                                min={1}
                                
                            />
                            <span></span>
                            <label>Account Number</label>

                            </div>

                            {/* Gender */}
                            <div className="txt_field">
                            <input
                                value={Gender}
                                onChange={(e) => setGender(e.target.value)}
                                type="text"
                                required
                            />
                            <span></span>
                            <label>Gender</label>

                            </div>
                            {/* Compensation */}
                            <div  className="txt_field">

                                    <input
                                            value={Compensation}
                                            onChange={(e) => setCompensation(e.target.value)}
                                            type="number"
                                            // placeholder="Password"
                                            required
                                            min={1}
                                        />

                                    <span></span>
                                    <label>Compensation</label>

                            </div>
                            {/* Compensation */}
                            <div  className="txt_field">

                                    <input
                                            value={position}
                                            onChange={(e) => setPosition(e.target.value)}
                                            type="text"
                                            // placeholder="Password"
                                            required
                                            // min={1}
                                        />

                                    <span></span>
                                    <label>Position</label>

                            </div>
                            {/* Compensation */}
                            {/* <div  className="txt_field">

                                    <input
                                            value={Compensation}
                                            onChange={(e) => setCompensation(e.target.value)}
                                            type="number"
                                            // placeholder="Password"
                                            required
                                            min={1}
                                        />

                                    <span></span>
                                    <label>Compensation</label>

                            </div> */}
                            {/* Compensation */}
                            <div  className="txt_field">

                                    <input
                                            value={address}
                                            onChange={(e) => setAddress(e.target.value)}
                                            type="text"
                                            // placeholder="Password"
                                            required
                                            // min={1}
                                        />

                                    <span></span>
                                    <label>Address</label>

                            </div>
                            {/* Compensation */}
                            <div  className="txt_field">

                                    <input
                                            value={doh}
                                            onChange={(e) => setDoh(e.target.value)}
                                            type="date"
                                            // placeholder="Password"
                                            required
                                          
                                        />

                                    <span></span>
                                    <label>Date of Hire</label>

                            </div>
                            {/* Compensation */}
                            <div  className="txt_field">

                                    <input
                                            value={FInstitution}
                                            onChange={(e) => setFInstitutionn(e.target.value)}
                                            type="text"
                                            // placeholder="Password"
                                            required
                                            // min={1}
                                        />

                                    <span></span>
                                    <label>Financial Institution</label>

                            </div>
                            {/* Compensation */}
                            <div  className="txt_field">

                                    <input
                                            value={AccountType}
                                            onChange={(e) => setAccountType(e.target.value)}
                                            type="text"
                                            // placeholder="Password"
                                            required
                                            // min={1}
                                        />

                                    <span></span>
                                    <label>Account Type</label>

                            </div>
                            {/* Compensation */}
                            <div  className="txt_field">

                                    <input
                                            value={AccountBranch}
                                            onChange={(e) => setAccountBranch(e.target.value)}
                                            type="text"
                                            // placeholder="Password"
                                            required
                                            // min={1}
                                        />

                                    <span></span>
                                    <label>Account Branch</label>

                            </div>
                            {/* Compensation */}
                            <div  className="txt_field">

                                    <input
                                            value={nik}
                                            onChange={(e) => setNik(e.target.value)}
                                            type="text"
                                            // placeholder="Password"
                                            required
                                            // min={1}
                                        />

                                    <span></span>
                                    <label>Next of Kin (NIK) Name</label>

                            </div>
                            {/* Compensation */}
                            <div  className="txt_field">

                                    <input
                                            value={nikRel}
                                            onChange={(e) => setNikRel(e.target.value)}
                                            type="text"
                                            // placeholder="Password"
                                            required
                                            // min={1}
                                        />

                                    <span></span>
                                    <label>Next of Kin Relationship</label>

                            </div>
                            {/* Compensation */}
                            <div  className="txt_field">

                                    <input
                                            value={nikAddress}
                                            onChange={(e) => setNikAddress(e.target.value)}
                                            type="text"
                                            // placeholder="Password"
                                            required
                                            // min={1}
                                        />

                                    <span></span>
                                    <label>Next of Kin Address</label>

                            </div>
                            {/* Compensation */}
                            <div  className="txt_field">

                                    <input
                                            value={nikContact}
                                            onChange={(e) => setNikContact(e.target.value)}
                                            type="text"
                                            // placeholder="Password"
                                            required
                                            // min={1}
                                        />

                                    <span></span>
                                    <label>Next of Kin Contact</label>

                            </div>
                          
                            

                            
                            {Loading ?<div>
                               
                                <BeatLoader color="#36d7b7" />
                            </div> :    
                            <>
                            <input type="submit" value="Add Employee" />
                           
                                
                                {successMsg && <div className="successMsgContainer">
                                            
                                            <p>{`Operation successfull! ${Msg}`}</p>
                                            
                                </div>}
                                {errorMsg && <div className="errorMsgContainer">
                                            
                                            <p>{`Operation Failed! ${Msg}`}</p>
                                            
                                </div>}

                                
                            
                            </>
                            }
                                
                            
                            
                        </form>
                    <br/>
                    <br/>
                </>
                {/* } */}

                                              


                                              {/* stop */}

                                                <div className={consist? "Consist Active": "Consist"} onClick={consistHandler}> 
                                                <div className='subHeading'>  
                                                        <div className='headTitle'> 
                                                                    <p>USERS</p> 
                                                        </div> 

                                                        <div className='plusSign'> 
                                                                    <h3>+</h3>
                                                        </div>

                                                        <div className='minusSign'> 
                                                                    <h3>-</h3>
                                                        </div>
                                                                            
                                                                            
                                                </div>
                                                
                                                <div className='VText' > 

                                                {/* <p>Registration (non-refundable) $285</p><br/> 
                                                <p>Admission Fee (non-refundable) $945</p><br/>
                                                <p>Refundable Deposit $2,000</p>
                                                <p>The deposit is refundable after the child has left Baobab College providing that the school has:</p><br/>  
                                                <p>1. Been given a minimum of 90 days written notice of withdrawal before the end of term</p>                                 
                                                <p>2. All books and equipment have been returned in good condition</p>
                                                <p>3. All fees and charges have been settled in full</p>
                                                
                                                     */}
                                                
                                <div className="compensationCard">
                                    
                                        {/* <div className="InpuTsubject"><p><b>Gender</b></p></div>
                                        <div className="InpuTvalue">Male</div> */}
                                        <table className="contentTable"> 
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th>Name</th>
                                                    <th>Gender</th>
                                                    <th>SSN</th>
                                                    <th>Email</th>
                                                    <th>Account_N0</th>
                                                    <th>Compensation</th>
                                                    {/* <th>Recepient</th> */}
                                                    
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {/* .filter(row => {
                                                let filterPass = true
                                                const date = new Date(row.dateYouWannaFilterWith)
                                                if (dateFilter.startDate) {
                                                filterPass = filterPass && (new Date(dateFilter.startDate) < date)
                                                }
                                                if (dateFilter.endDate) {
                                                filterPass = filterPass && (new Date(dateFilter.endDate) > date)
                                                }
                                                //if filterPass comes back `false` the row is filtered out
                                                return filterPass
                                            }) */}
                                            
                                                {tData && tData
                                               
                                                .map((item,index)=>{
                                                
                                                //   console.log("Item",item)
                                                // var isod =  new Date(item.TDate).toISOString();
                                                var isod ="";
                                                //   var dates = format(isod, 'yyyy-MM-dd') 
                                                //    var datee = new Date(item.TDate)
                                                //    console.log("Date here",isod.toString().substring(2, 10))
                                                return(  
                                                <tr>

                                                    <td>{index+1}</td>
                                                    <td>{index.name}</td>
                                                    {/* <td>{new Date()}</td> */}
                                                    <td>{item.Gender} </td>
                                                    <td>{item.Ssn} </td>
                                                    <td>{item.email}</td>
                                                    <td>{item.AccountNo}</td>
                                                    <td>{item.Base_Pay}</td>
                                                    {/* <td>{item.TAccount}</td> */}
                                                    {/* <td>{item.TAccount}</td> */}
                                                    
                                                </tr>
                                            )
                                            })}
                                            
                                            
                                            </tbody>
                                        </table>

                                    </div>


                                                </div>

                                                
                                                </div>  


                                                </div>

                                            

                                                {/* <div className='vitueImage'> 
                                                            <img src={img1} />

                                                </div> */}
                                            

                                        </div>

                                    {/* dagfgahadf */}

                                </div>

           </div>

        
        </>
    )

}

export default AddUser;
